<template>
  <div>
    <!-- 自定义表单弹窗 -->
    <custom-form-dialog
      :visible.sync="customFormDialog.visible"
      :form-config="customFormDialog.formConfig"
      :page-parts="customFormDialog.pageParts"
      :jobs="jobs"
      :tenant-instructions="tenantInstructions"
      @callback="onCustomFormCallback"
    />
  </div>
</template>

<script>
import CustomFormDialog from '@/components/Cargo/Job/customFormWindow/customFormDialog'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { generateInstructionRecord } from '@/api/sysManage/baseConfig/instruction'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { queryFormByUuid } from '@/api/sysManage/aiCustomPage'

export default {
  name: 'CustomFormWindow',
  components: { CustomFormDialog },
  data() {
    return {
      isSop: false,
      tenantInstruction: {
        uuid: '',
        platformInstructionCode: '',
        allowMultipleOperations: false
      },
      singleTicketBusinessEntry: false,
      batchBusinessProcessing: false,
      singleFormUuid: '',
      batchFormUuid: '',
      jobs: [],
      job: {},
      trackingCode: '',
      isBatch: false,
      tenantInstructions: [],
      customFormDialog: {
        visible: false,
        formConfig: {},
        pageParts: []
      }
    }
  },
  methods: {
    // UI自定义使用
    onShowOfUI(uiInstruction, job, jobs) {
      this.isSop = false
      this.tenantInstruction.uuid = uiInstruction.tenantInstructionUuid
      this.tenantInstruction.platformInstructionCode = uiInstruction.platformInstructionRuleCode
      this.tenantInstruction.allowMultipleOperations = uiInstruction.allowMultipleOperations || false
      if (uiInstruction.instructionRuleJson) {
        this.singleTicketBusinessEntry = uiInstruction.instructionRuleJson.singleTicketBusinessEntry || false
        this.batchBusinessProcessing = uiInstruction.instructionRuleJson.batchBusinessProcessing || false
        this.singleFormUuid = uiInstruction.instructionRuleJson.singleFormUuid || ''
        this.batchFormUuid = uiInstruction.instructionRuleJson.batchFormUuid || ''
      } else {
        this.singleTicketBusinessEntry = false
        this.batchBusinessProcessing = false
        this.singleFormUuid = ''
        this.batchFormUuid = ''
      }
      this.jobs = jobs != null ? jobs : [job]
      this.job = this.jobs[0] // 保留向后兼容，但可以从jobs[0]获取
      this.trackingCode = ''
      this.isBatch = jobs != null
      switch (this.tenantInstruction.platformInstructionCode) {
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM.code:
          this.showCustomFormDialog()
          break
        default:
          break
      }
    },
    // SOP面板使用
    onShowOfSOP(sopInstruction, jobs, trackingCode, isBatch = false, tenantInstructions = []) {
      this.isSop = true
      this.tenantInstruction.uuid = sopInstruction.uuid
      this.tenantInstruction.platformInstructionCode = sopInstruction.platformInstructionCode
      this.tenantInstruction.allowMultipleOperations = sopInstruction.allowMultipleOperations || false
      if (sopInstruction.instructionRuleJson) {
        this.singleTicketBusinessEntry = sopInstruction.instructionRuleJson.singleTicketBusinessEntry || false
        this.batchBusinessProcessing = sopInstruction.instructionRuleJson.batchBusinessProcessing || false
        this.singleFormUuid = sopInstruction.instructionRuleJson.singleFormUuid || ''
        this.batchFormUuid = sopInstruction.instructionRuleJson.batchFormUuid || ''
      } else {
        this.singleTicketBusinessEntry = false
        this.batchBusinessProcessing = false
        this.singleFormUuid = ''
        this.batchFormUuid = ''
      }
      this.jobs = jobs
      this.job = jobs[0] // 保留向后兼容，但可以从jobs[0]获取
      this.trackingCode = trackingCode
      this.isBatch = jobs.length > 1 ? isBatch : false
      this.tenantInstructions = tenantInstructions
      switch (this.tenantInstruction.platformInstructionCode) {
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM.code:
          this.showCustomFormDialog()
          break
        default:
          break
      }
    },
    async showCustomFormDialog() {
      if (this.isBatch) {
        if (!this.batchBusinessProcessing) {
          this.$message.warning(this.$t('CargoMsg.BatchProcessingIsNotSupported'))
          return
        }
        if (!this.batchFormUuid) {
          this.$message.warning(this.$t('CargoMsg.BatchFillingIsNotConfigured'))
          return
        }
      } else {
        if (!this.singleTicketBusinessEntry) {
          this.$message.warning(this.$t('CargoMsg.SingleEntryIsNotSupported'))
          return
        }
        if (!this.singleFormUuid) {
          this.$message.warning(this.$t('CargoMsg.SingleFormIsNotConfigured'))
          return
        }
      }

      const loading = getLoading4Cxt()
      const res = await queryFormByUuid({ uuid: this.isBatch ? this.batchFormUuid : this.singleFormUuid }).finally(() => {
        loading.close()
      })
      if (res.data) {
        const formConfig = res.data
        const outputParams = this.analysisOutputAPI(formConfig.outputApi)
        if (outputParams.jobState) {
          for (const job of this.jobs) {
            if (!outputParams.jobState.includes(job.jobState) && job.jobState !== SystemConstants.STATE_OPERATING.code) {
              this.$message.warning(this.$t(job.jobNo + this.$t('queryJob.NonEditable')))
              return
            }
          }
        } else {
          for (const job of this.jobs) {
            if (job.jobState !== SystemConstants.STATE_OPERATING.code) {
              this.$message.warning(this.$t(job.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
              return
            }
          }
        }
        formConfig.outputParams = outputParams
        this.customFormDialog.formConfig = formConfig
        if (formConfig.pageParts && formConfig.pageParts.length > 0) {
          this.customFormDialog.pageParts = formConfig.pageParts.map(pagePart => ({
            ...pagePart,
            id: pagePart.serialNumber,
            isEditing: false,
            editingName: ''
          }))
        } else {
          this.customFormDialog.pageParts = []
        }
        this.customFormDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.TheFormDoesNotExist'))
      }
    },
    analysisOutputAPI(outputAPI) {
      const obj = {}
      if (!outputAPI) {
        return obj
      }
      outputAPI.replace(/([^&=]+)=([^&=]*)/g, function(rs, $1, $2) {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
      })
      if (obj.jobState) {
        const labels = Array.from(obj.jobState.split(','), item => item.trim())
        const vals = []
        for (const item of SystemConstants.JOB_STATES) {
          if (labels.includes(item.chineseName)) {
            vals.push(item.code)
          }
        }
        obj.jobState = vals
      }
      return obj
    },
    onCustomFormCallback() {
      const jobUuids = this.isBatch ? this.jobs.map(job => job.uuid) : [this.job.uuid]
      this.instructionCallback({ jobUuids, executeStatus: true, instructionUuid: this.tenantInstruction.uuid })
    },
    async instructionCallback(data) {
      const loading = getLoading4Cxt(this.$parent)
      await generateInstructionRecord(data).finally(() => {
        loading.close()
      })
      this.$emit('instructionCallback', { platformInstructionCode: this.tenantInstruction.platformInstructionCode })
    }
  }
}
</script>
